(() => {
  angular.module('pims').filter('decodeHtml', [
    '$sanitize',
    $sanitize => {
      'ngInject';
      const cache = new Map();

      // Escape HTML so user text cannot be interpreted as live markup.
      const escapeHtml = text =>
        text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');

      // Break AngularJS interpolation delimiters with a zero-width space so
      // $compile cannot evaluate {{ }} expression-injection payloads.
      const ZWSP = '\u200B';
      const neutralizeInterpolation = text => text.replace(/\{\{/g, `{${ZWSP}{`).replace(/\}\}/g, `}${ZWSP}}`);

      // Regex to match trusted widget tags and <a> link tags generated by prior filters.
      const TRUSTED_TAG_RE = /(<lib-widget-[\w-]+\s[^>]*>.*?<\/lib-widget-[\w-]+>|<a\s[^>]*>.*?<\/a>|<br\s*\/?>)/gi;

      return message => {
        const stringToDecode = message.content;
        if (!stringToDecode || typeof stringToDecode !== 'string') {
          return stringToDecode;
        }
        if (cache.has(stringToDecode)) {
          return cache.get(stringToDecode);
        }
        const decodedOnce = stringToDecode.replace(/&amp;/g, '&');
        const txt = document.createElement('textarea');
        txt.innerHTML = decodedOnce;
        const decoded = txt.value;

        // Check if the content contains lib-widget elements
        const hasWidgets = /<lib-widget-[^>]+>/i.test(decoded);

        let sanitizedContent;
        if (!FEATURE_BODACDC_2674) {
          // Legacy behaviour — no XSS protection beyond $sanitize for non-widget content
          if (hasWidgets) {
            sanitizedContent = decoded;
          } else {
            sanitizedContent = $sanitize(decoded);
          }
        } else if (hasWidgets) {
          // For widget content: escape user text segments, preserve trusted tags.
          // Split by trusted tags, escape the text between them, reassemble.
          const parts = decoded.split(TRUSTED_TAG_RE);
          sanitizedContent = parts
            .map(part => {
              if (TRUSTED_TAG_RE.test(part)) {
                // Reset lastIndex since we use global flag
                TRUSTED_TAG_RE.lastIndex = 0;
                return part; // Keep trusted tags intact
              }
              TRUSTED_TAG_RE.lastIndex = 0;
              return escapeHtml(neutralizeInterpolation(part));
            })
            .join('');
        } else {
          // For regular content, use sanitization (already strips XSS).
          // Then neutralize interpolation for the $compile pass.
          sanitizedContent = neutralizeInterpolation($sanitize(decoded));
        }
        cache.set(stringToDecode, sanitizedContent);
        return sanitizedContent;
      };
    },
  ]);
})();
